import { render, staticRenderFns } from "./CreateArtistOrder.vue?vue&type=template&id=dca76840&scoped=true"
import script from "./CreateArtistOrder.vue?vue&type=script&lang=js"
export * from "./CreateArtistOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca76840",
  null
  
)

export default component.exports